import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/home/vsts/work/1/s/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/app/management/navbar/managementNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/auth/msal/myMsalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommonContentProvider"] */ "/home/vsts/work/1/s/src/shared/components/context/commonContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutButton"] */ "/home/vsts/work/1/s/src/shared/components/logoutButton/logoutButton.tsx");
